var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "ak-modal",
        {
          attrs: { active: _vm.show, title: "Modal title", width: "1000px" },
          on: { close: _vm.closeModal },
        },
        [
          _c("iframe", {
            attrs: {
              src:
                "https://www.bookwidgets.com/lti/login?iss=" + _vm.bwIssuerId,
              width: "100%",
              height: "600px",
              title: "Sync exercises",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }